import { PASSWORD_REGEX } from '@/constants/constants'
import type { Errors } from '../types'

type Payload = {
  newPassword: string
  newPasswordRepeat: string
}

const useValidate = () => {
  const validate = (payload: Payload) => {
    const validationErrors: Errors = {}

    if (!payload.newPassword) {
      validationErrors.newPassword = 'This field is required'
    }

    if (!payload.newPasswordRepeat) {
      validationErrors.newPasswordRepeat = 'This field is required'
    } else if (
      payload.newPassword.length > 0 &&
      !PASSWORD_REGEX.exec(payload.newPassword)
    ) {
      validationErrors.newPassword = 'Please follow the password rules'
    } else if (payload.newPassword !== payload.newPasswordRepeat) {
      validationErrors.newPasswordRepeat = 'Passwords do not match'
    }

    return {
      validationErrors,
      isValid: !Object.values(validationErrors).some((error) => error),
    }
  }

  return validate
}

export default useValidate
